import React, { useState, useEffect } from 'react'
import PageHeader from '../../../components/common/PageHeader'
import CustomerDynamicTable from '../../../components/common/CustomerDynamicTable';
import { getUserInfo } from '../../../utils/token';
import { 
  getCustomerDevicesList, 
  createCustomerDevice, 
  updateCustomerDevice, 
  registerCustomerDevice, 
  deviceQrCodeScan,
  deviceLogout,
  deviceDelete
} from '../../../api/endpoints/customer';
import CustomerAddDeviceFormModel from '../../../components/modals/forms/customer/CustomerAddDeviceFormModel';
import showSuccessAlert from '../../../utils/swalAlerts/showSuccessAlert';
import showErrorAlert from '../../../utils/swalAlerts/showErrorAlert';
import { showDeleteAlert } from '../../../utils/swalAlerts/showDeleteAlert';
import QrCodeModal from '../../../components/modals/forms/customer/QrCodeModal';
import TestTextMessageModal from '../../../components/modals/forms/customer/TestTextMessageModal';
import { SendTestTextMsg } from '../../../api/endpoints/message';
import SubscriptionWidget from '../../../components/common/SubscriptionWidget';

const List = () => {
  const [companyId, setCompanyId] = useState(null);
  const [customerId, setCustomerId] = useState([]);
  const [listData, setListData] = useState([]);
  const [addModalVisible, setAddModalVisible] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedRow, setSelectedRow] = useState({});
  const [ device, setDevice ] = useState({});
  const [ showQrCode, setShowQrCode ] = useState(false);
  const [ qrSrc, setQrSrc ] = useState("");
  const [ showTestMsg, setShowTestMsg] = useState(false);

  useEffect(()=>{
    async function fetchData() {
      const {compId, userId} = getUserInfo();
      setCompanyId(compId);
      setCustomerId(userId);
      const response  = await getCustomerDevicesList(compId, userId);
      //console.log(response);
      if(response.status === 200){
        console.log(response.data.data);
        setListData(response.data.data);
      }else{
        // show alert something went wrong
      }
    }
    fetchData();  
  },[]);

  const headerColumns = [
    { header: "Mobile Number", accessor: "mobile"},
    { header: "Callback URL", accessor: "call_back_url"},
    {
      header: "Status",
      accessor: "device_status",
      render: (value) => (
        <span className={`badge ${value === "connected" ? "bg-success" : "bg-danger"}`}>
          {value ? value : "Not Scaned"}
        </span>
      ),
    },
  ];

  const handleAdd = async () => {
    setSelectedId(null);
    setAddModalVisible(true);
  }
  const handleEdit = async (row) => {
    console.log(row);
    setSelectedId(row.device_id);
    setSelectedRow(row);
    setAddModalVisible(true);
  }
  const handleView = async () => {
    
  }
  const handleDelete = async (row) => {
    showDeleteAlert({
      title: 'Are you sure you want to delete this device',
      message: '',
      confirmButtonText: 'Yes, sure',
      isInfo: true,
      onConfirm: async () => {
        try {
          const response = await deviceDelete(companyId, customerId, row.device_id);
          if(response.status === 200){
            // send sucess 
            //console.log(response.data);
            if(response.data.success){
              showSuccessAlert({
                title: "Device Logout Status",
                message: response.data.message,
                icon: "success",
                cancelText : 'Ok',
                onBack: () => window.location.reload(),
              })
            }else{
              showErrorAlert({
                title: "Oops...! Something went Wrong !",
                message: "Please try after sometime.",
                icon: "error",
              })
            }
            
          }
          // Optionally refresh data or show success alert
        } catch (error) {
          console.error('Delete failed:', error);
          // Optionally show error alert
          showErrorAlert({
            title: "Oops...! Something went Wrong !",
            message: error.message,
            icon: "error",
          })
        }
      }
    });
  }

  const handleSendMsg = async (row) => {
    console.log(row);
    setSelectedRow(row);
    setShowTestMsg(true);
  }

  const handleTestMsgSend = async (row) => {
    const response = await SendTestTextMsg(customerId, row.device_id, row.text_message, row.fromMobile, row.toMobile);
    console.log(response);
    if(response.data.success){
      showSuccessAlert({
        title: "Successful!",
        message: response.data.message,
        icon: "success",
        cancelText : 'Ok',
      })
    }else{
      showErrorAlert({
        title: "Oops...! Something went Wrong !",
        message: response.data.message,
        icon: "error",
      })
    }

  }
  const handleScan = async (row) => {
    const regDevice = await registerCustomerDevice(companyId, customerId, row.device_id);
    if(regDevice.status === 200 && regDevice.data.success === true){
      console.log(regDevice.data);
      console.log(regDevice.data.data);
      // show into a 
      setQrSrc(regDevice.data.data);
      setShowQrCode(true);
    }else{
      showErrorAlert({
        title: "Oops...! Something went Wrong !",
        message: regDevice.data.data.message,
        icon: "error",
      })
    }
  }

  const refetchQR = async () => {

  }

  const handleDeviceLogout = async (row) => {
    showDeleteAlert({
      title: 'Are you sure you want to Logout this device',
      message: '',
      confirmButtonText: 'Yes',
      isInfo: true,
      onConfirm: async () => {
        try {
          const response = await deviceLogout(companyId, customerId, row.device_id);
          if(response.status === 200){
            // send sucess 
            //console.log(response.data);
            if(response.data.success){
              showSuccessAlert({
                title: "Device Logout Status",
                message: response.data.message,
                icon: "success",
                cancelText : 'Ok',
                onBack: () => window.location.reload(),
              })
            }else{
              showErrorAlert({
                title: "Oops...! Something went Wrong !",
                message: "Please try after sometime.",
                icon: "error",
              })
            }
            
          }
          // Optionally refresh data or show success alert
        } catch (error) {
          console.error('Delete failed:', error);
          // Optionally show error alert
          showErrorAlert({
            title: "Oops...! Something went Wrong !",
            message: error.message,
            icon: "error",
          })
        }
      }
    });
  }

  const handleDeviceSave = async (device) => {
    let response = {}
    if (device.device_id) {
      response = await updateCustomerDevice(companyId, customerId, device);   
    }else{
      //setDevice((prev) => [...prev, { ...device, device_id: Date.now().toString() }]);
      response = await createCustomerDevice(companyId, customerId, device);    
    }
    
    if(response.status === 200 && response.data.success === true){
      showSuccessAlert({
        title: "Successful!",
        message: response.data.message,
        icon: "success",
        cancelText : 'Ok',
        onBack: () => window.location.reload(),
      })
    }else{
      showErrorAlert({
        title: "Oops...! Something went Wrong !",
        message: response.data.message,
        icon: "error",
      })
    }

  }

  const closeQrModal = () => {
    setShowQrCode(false);
     window.location.reload();
  }

  return (
    <>
      <PageHeader  title="Devices List" breadcrumbs={[ {label: 'Customer'}, {label: 'Devices List'}]}/>
      <SubscriptionWidget 
        compId ={companyId}
        customerId = {customerId}
      />
      <CustomerDynamicTable 
        data={listData}
        columns={headerColumns}
        onAdd={handleAdd}
        onEdit={handleEdit}
        onSendMsg = {handleSendMsg}
        onDelete={handleDelete}
        onScan={handleScan}
        onLogout={handleDeviceLogout}
      />
      <CustomerAddDeviceFormModel 
        show={addModalVisible}
        onClose={() => setAddModalVisible(false)}
        onSave={handleDeviceSave}
        compId={companyId}
        customerId={customerId}
        deviceId={selectedId}
        selectedRowDetails={selectedRow}
      />
      <QrCodeModal 
        isOpen={showQrCode}
        onClose={ closeQrModal}
        qrValue={qrSrc}
        title="Scan QR Code"
        description="Scan qr code to connect your whats app with us "
        onRetry={refetchQR}
      />

      <TestTextMessageModal 
        show={showTestMsg}
        onClose={() => setShowTestMsg(false)}
        selectedRowDetails={selectedRow}
        onSave={handleTestMsgSend}
      />
    </>
  )
}

export default List